import n from "./td-longtail-vue-components186.js";
import o from "./td-longtail-vue-components3.js";
/* empty css                              */
import r from "./td-longtail-vue-components98.js";
const i = {
  name: "AddToCartButton",
  components: {
    LinkButton: o,
    cartIcon: n
  },
  props: {
    buttonTitle: {
      type: String,
      default: "Artikel in den Warenkorb legen"
    },
    buttonText: {
      type: String,
      default: "In den Warenkorb"
    },
    displayIcon: {
      type: Boolean,
      default: !1
    },
    displayText: {
      type: Boolean,
      default: !0
    },
    tealiumSuffix: {
      type: String,
      default: null
    },
    theme: {
      type: String,
      default: "primary",
      validator(e) {
        return ["primary", "light", "default"].includes(e);
      }
    },
    disabled: {
      type: Boolean
    },
    large: {
      type: Boolean
    },
    medium: {
      type: Boolean
    }
  },
  emits: ["add-to-cart"],
  data() {
    return {
      cartIcon: n
    };
  },
  computed: {
    classContainer() {
      const e = [];
      return this.displayText && e.push("add-to-cart-button--has-label"), e.join(" ");
    }
  },
  methods: {
    emitAddToCart(e) {
      e.preventDefault(), this.$emit("add-to-cart", e);
    }
  }
};
var l = function() {
  var t = this, a = t._self._c;
  return a("LinkButton", { ref: "button", staticClass: "add-to-cart-button", class: t.classContainer, attrs: { tag: "button", disabled: t.disabled, "tealium-name": t.buttonText, "tealium-suffix": t.tealiumSuffix, "aria-label": t.buttonTitle, primary: t.theme === "primary", "outline-light": t.theme === "light", "icon-only": t.displayIcon && !t.displayText, medium: t.medium, large: t.large, "small-padding": "" }, on: { click: t.emitAddToCart } }, [t._t("badge"), t.displayIcon ? a("cartIcon", { staticClass: "add-to-cart-button__icon", class: `add-to-cart-button__icon--${t.theme}`, attrs: { "aria-hidden": "true" } }) : t._e(), t.displayText ? a("span", { staticClass: "add-to-cart-button__text" }, [t._t("default", function() {
    return [t._v(t._s(t.buttonText))];
  })], 2) : t._e()], 2);
}, d = [], s = /* @__PURE__ */ r(
  i,
  l,
  d,
  !1,
  null,
  "1009c152"
);
const f = s.exports;
export {
  f as default
};
